module.exports = __webpack_public_path__ + "img/ltkkids-3x.9daa067.jpg";